<template>
    <div class="main">
        <div class="tab_box">
            <div class="tab" :class="[GetClassOfStyle(AssessTabActive==false,'on')]" @click="AssessTabBtn(false)">待评估<span class="num">{{dataNumber1}}</span></div>
            <div class="tab" :class="[GetClassOfStyle(AssessTabActive==true,'on')]" @click="AssessTabBtn(true)">已评估<span class="num">{{dataNumber2}}</span></div>
        </div>
        <div class="listbox" v-show="AssessTabActive==false">
            <el-table :data="mainData.Data" style="width: 100%" height="400">
                <el-table-column prop="wishType" label="类型" width="120">
                    <template slot-scope="scope">
                        <el-tag class="item" size="mini" :type="scope.row.ZYType === 1 ? 'danger' : ''">{{ scope.row.ZYType
                            ===
                            1 ? nameConfig.WDF : nameConfig.WCF }}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="ZYName" label="志愿信息">
                </el-table-column>
                <el-table-column prop="Score" label="分数" width="100">
                </el-table-column>
                <el-table-column prop="ExamProvinceName" label="高考省份" width="100">
                </el-table-column>
                <el-table-column prop="Subjects" label="选科" width="200">
                    <template slot-scope="scope">
                        <span v-if="scope.row.SubjectType==1||scope.row.SubjectType==2">首选:{{scope.row.SubjectType==1?'物理':'历史'}} 再选:{{scope.row.Subjects}}</span>
                        <span v-else-if="scope.row.SubjectType==3||scope.row.SubjectType==4">{{scope.row.SubjectType==3?'理科':'文科'}}</span>
                        <span v-else>{{ scope.row.Subjects }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="BatchName" label="批次" width="120">
                </el-table-column>
                <el-table-column label="操作" width="80">
                    <template slot-scope="scope">
                        <el-button size="mini" type="text" @click="assessItem(scope.row)">志愿评估中…</el-button>
                        <!-- <el-button class="color-red" size="mini" type="text" @click="deleteItem(scope.row)">删除</el-button> -->
                    </template>
                </el-table-column>
            </el-table>
            <div class="tipsbox">
                <div v-if="mainData.Total>0">
                    您有 {{mainData.Total}} 条待评估的志愿，请及时联系平台进行评估<span v-if="Web_TelPhone">，联系电话：{{Web_TelPhone}}</span>
                </div>
            </div>
            <div class="pagination">
                <el-pagination layout="total, sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 50, 100]"
                    :total="mainData.Total" @size-change="handleSize" @current-change="handlePage"></el-pagination>
            </div>
        </div>
        <div class="listbox" v-show="AssessTabActive==true">
            <el-table :data="mainData2.Data" style="width: 100%" height="450">
                <el-table-column prop="wishType" label="类型" width="120">
                    <template slot-scope="scope">
                        <el-tag class="item" size="mini" :type="scope.row.ZYType === 1 ? 'danger' : ''">{{ scope.row.ZYType
                            ===
                            1 ? nameConfig.WDF : nameConfig.WCF }}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="ZYName" label="志愿信息">
                </el-table-column>
                <el-table-column prop="Score" label="分数" width="100">
                </el-table-column>
                <el-table-column prop="ExamProvinceName" label="高考省份" width="100">
                </el-table-column>
                <el-table-column prop="Subjects" label="选科" width="200">
                    <template slot-scope="scope">
                        <span v-if="scope.row.SubjectType==1||scope.row.SubjectType==2">首选:{{scope.row.SubjectType==1?'物理':'历史'}} 再选:{{scope.row.Subjects}}</span>
                        <span v-else-if="scope.row.SubjectType==3||scope.row.SubjectType==4">{{scope.row.SubjectType==3?'理科':'文科'}}</span>
                        <span v-else>{{ scope.row.Subjects }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="BatchName" label="批次" width="120">
                </el-table-column>
                <el-table-column label="操作" width="80">
                    <template slot-scope="scope">
                        <el-button size="mini" type="text" @click="assessItem(scope.row)">查看评估</el-button>
                        <!-- <el-button class="color-red" size="mini" type="text" @click="deleteItem(scope.row)">删除</el-button> -->
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination layout="total, sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 50, 100]"
                    :total="mainData2.Total" @size-change="handleSize2" @current-change="handlePage2"></el-pagination>
            </div>
        </div>
    </div>
</template>
<script>
import API from '@/api/config'
import {mapGetters} from 'vuex'
import { getStore, setStore } from '@/utils/utils'
export default {
    data() {
        return {
            mainData: {},
            mainData2: {},
            dataNumber1:0,
            dataNumber2:0,
            query: {
                PageIndex: 1,
                PageSize: 10
            },
            query2: {
                PageIndex: 1,
                PageSize: 10
            },
            studentReport:{},
            AssessTabActive:false,
            Web_TelPhone:''
        }
    },
    computed: {
        ...mapGetters(['nameConfig'])
    },
    mounted() {
        let pdata = getStore("ParamList");
        if(pdata){
            pdata = JSON.parse(pdata);
            let obj = pdata.find(f=>f.ParamKey=='Web_TelPhone');
            if(obj){
                this.Web_TelPhone = obj.ParamValue;
            }
        }
        this.getList();//获取评估列表（未评估）
        this.getList2();//获取评估列表（已评估）
    },
    methods: {
        GetClassOfStyle(code,str,str2){
            if(code){
                return str;
            }
            else{
                return (str2?str2:'');
            }
        },
        //评估状态Tab切换
        AssessTabBtn(val){
            this.AssessTabActive=val;
        },
        //获取评估列表（未评估）
        getList() {
            API.Personal.GetZYEvaluateList({IsEvaluated: false}, {pageIndex: this.query.PageIndex, pageSize: this.query.PageSize}).then(res => {
                if(res.code==0){
                    this.mainData = res.data;
                    this.dataNumber1=res.data.Total;
                }
            });
        },
        //获取评估列表（已评估）
        getList2() {
            API.Personal.GetZYEvaluateList({IsEvaluated: true}, {pageIndex: this.query2.PageIndex, pageSize: this.query2.PageSize}).then(res => {
                if(res.code==0){
                    this.mainData2 = res.data;
                    this.dataNumber2=res.data.Total;
                }
            });
        },
        //查看评估
        assessItem(row){
            if(row.IsEvaluated==false){
                return;
            }
            let url = this.$router.resolve({
                path: '/wishassess',
                query: {
                    WishId: row.Id,
                    ZYWay: row.ZYWay,
                    ZYId: row.ZYId
                }
            })
            window.open(url.href, '_blank')
        },

        // delete
        deleteItem(row) {
            this.$confirm("您确定删除该志愿评估吗？", "注意！", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
                lockScroll: true,
            }).then(() => {
                
            }).catch(() => { })
        },
        // 分页
        handlePage(val) {
            this.query.PageIndex = val
            this.getList()
        },
        handleSize(val) {
            this.query2.PageIndex = 1
            this.query2.PageSize = val
            this.getList()
        },
        // 分页
        handlePage2(val) {
            this.query.PageIndex = val
            this.getList2()
        },
        handleSize2(val) {
            this.query2.PageIndex = 1
            this.query2.PageSize = val
            this.getList2()
        },
    }
}
</script>
<style lang="less" scoped>
.main {
    .tab_box{
        width: 100%;
        height: 40px;
        background-color: #f5f5f5;
        .tab{
            display: inline-block;
            width: 50%;
            height: 40px;
            line-height: 40px;
            text-align: center;
            font-size: 16px;
            color: #555;
            background-color: #c9c2c2;
            position: relative;
            &:hover{
                cursor: pointer;
            }
            .num{
                position: absolute;
                display: inline-block;
                color: red;
                font-size: 14px;
                top: -5px;
                z-index: 1;
                margin-left: 5px;
            }
        }
        .tab.on{
            background-color: #f8f6f6;
        }
    }
    .listbox{
        padding: 0 40px;
        .color-red {
            color: #f56c6c;
        }
        .pagination {
            margin: 10px 0 10px 10px;
        }
        .tipsbox{
            height: 50px;
            width: 100%;
            line-height: 50px;
            color: #e40404;
            font-size: 14px;
            text-indent: 20px;
        }
    }
}
</style>